import axios from 'axios';

import { env } from 'config';
import { SciDomain } from 'types';

const url = `${env.apiUrl}/v1/sci-domains`;

const getOneForOrder = async (id: string, token: string): Promise<SciDomain> =>
  (
    await axios.get(`${url}/orders/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  ).data;

export const sciDomainsApi = {
  getOneForOrder,
};
